import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { NavigationDirection } from './NavigationDirection';

const useNavigationDirection = (): NavigationDirection | null => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const [direction, setDirection] = useState<NavigationDirection | null>(null);
  const prevLocation = useRef(location);

  useEffect(() => {
    if (prevLocation.current !== location) {
      if (navigationType === 'PUSH') {
        setDirection(NavigationDirection.Forward);
      } else if (navigationType === 'POP') {
        setDirection(NavigationDirection.Backward);
      }
    }
    prevLocation.current = location;
  }, [location, navigationType]);

  return direction;
};

export default useNavigationDirection;